<template>
    <div class="w-full overflow-hidden bg-white mt-4 mb-24 font-poppins">
        <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
        :title="tittle"
        />
        <!-- LOADER -->
        <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white  z-50">
          <img
            src="@/assets/imgs/tuin_loader_v2.gif"
            alt="cargando..."
            class=" w-[500px]"
          >
        </div>
        
        <main class="w-full px-4 md:px-6 lg:px-8 xl:px-[100px] py-8 md:py-12">
          <div class="max-w-[384px] mx-auto lg:mx-0">
            <!-- Title Section -->
            <div class="mb-6 md:mb-8">
              <h2 class="w-96 h-7 justify-center text-black text-xl font-medium font-['Poppins'] leading-normal">
                Activa tu Plan Estándar
              </h2>
              <p class="w-96 h-7 justify-center text-neutral-500 text-base font-normal font-['Poppins'] leading-tight">
                Y comienza a publicar propiedades
              </p>
            </div>

            <!-- Payment Form -->
            <form @submit.prevent="handleSubmit" class="space-y-3">
              <!-- Full Name Input -->
              <div class="flex flex-col gap-1.5">
                <label class="text-neutral-500 text-sm font-medium">
                  Nombre Completo*
                </label>
                <input
                  v-model="formData.fullName"
                  type="text"
                  placeholder="Ingresa tu nombre completo"
                  class="w-full px-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                  required
                >
              </div>

              <!-- Card Number Input -->
              <div class="flex flex-col gap-1.5">
                <label class="text-neutral-500 text-sm font-medium">
                  Número de tarjeta*
                </label>
                <input
                  v-model="formData.cardNumber"
                  type="text"
                  placeholder="Ingresa el número de tu tarjeta"
                  maxlength="19"
                  @input="formatCardNumber"
                  class="w-full px-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                  required
                >
              </div>

              <!-- CVC Input -->
              <div class="flex flex-col gap-1.5">
                <label class="text-neutral-500 text-sm font-medium">
                  CVC*
                </label>
                <input
                  v-model="formData.cvc"
                  type="text"
                  placeholder="Ingresa el código de seguridad"
                  maxlength="4"
                  @input="formatCVC"
                  class="w-full px-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                  required
                >
              </div>

              <!-- Expiration Date Input -->
              <div class="flex flex-col gap-1.5">
                <label class="text-neutral-500 text-sm font-medium">
                  Fecha de expiración*
                </label>
                <div class="relative">
                  <div class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path 
                        fill-rule="evenodd" 
                        clip-rule="evenodd" 
                        d="M0 2.5C0 1.96957 0.210714 1.46086 0.585786 1.08579C0.960859 0.710714 1.46957 0.5 2 0.5L14 0.5C14.5304 0.5 15.0391 0.710714 15.4142 1.08579C15.7893 1.46086 16 1.96957 16 2.5V14.5C16 15.0304 15.7893 15.5391 15.4142 15.9142C15.0391 16.2893 14.5304 16.5 14 16.5H2C1.46957 16.5 0.960859 16.2893 0.585786 15.9142C0.210714 15.5391 0 15.0304 0 14.5V2.5ZM15 4.5H11V7.5H15V4.5ZM15 8.5H11V11.5H15V8.5ZM15 12.5H11V15.5H14C14.2652 15.5 14.5196 15.3946 14.7071 15.2071C14.8946 15.0196 15 14.7652 15 14.5V12.5ZM10 15.5V12.5H6V15.5H10ZM5 15.5V12.5H1V14.5C1 14.7652 1.10536 15.0196 1.29289 15.2071C1.48043 15.3946 1.73478 15.5 2 15.5H5ZM1 11.5H5V8.5H1V11.5ZM1 7.5H5V4.5H1V7.5ZM6 4.5V7.5H10V4.5H6ZM10 8.5H6V11.5H10V8.5Z" 
                        fill="#737373"
                      />
                    </svg>
                  </div>
                  <input
                    v-model="formData.expirationDate"
                    type="text"
                    placeholder="MM/AA"
                    maxlength="5"
                    @input="formatExpirationDate"
                    class="w-full pl-10 pr-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                    required
                  >
                </div>
              </div>

              <!-- Submit Button -->
              <div class="pt-4">
                <button
                  type="submit"
                  :disabled="!isFormValid || loader_profile"
                  class="w-full px-5 py-2.5 bg-rose-500 text-white text-sm font-medium rounded-lg border border-rose-500 hover:bg-rose-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
                >
                  <span v-if="!loader_profile">Pagar</span>
                  <span v-else>Procesando...</span>
                </button>
              </div>
            </form>
          </div>
        </main>  
    </div>
      
</template>

<script setup>
  import { ref, computed } from 'vue';

  const toastAlert = ref(false);
  const typeMsg = ref('');
  const msg = ref('');
  const tittle = ref('');
  const loader_profile = ref(false);

  const formData = ref({
    fullName: '',
    cardNumber: '',
    cvc: '',
    expirationDate: ''
  });

  const isFormValid = computed(() => {
    return (
      formData.value.fullName.trim() !== '' &&
      formData.value.cardNumber.replace(/\s/g, '').length >= 13 &&
      formData.value.cvc.length >= 3 &&
      formData.value.expirationDate.length === 5
    );
  });

  function formatCardNumber(event) {
    let value = event.target.value.replace(/\s/g, '');
    value = value.replace(/\D/g, '');
    
    let formattedValue = '';
    for (let i = 0; i < value.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += ' ';
      }
      formattedValue += value[i];
    }
    
    formData.value.cardNumber = formattedValue;
  }

  function formatCVC(event) {
    let value = event.target.value.replace(/\D/g, '');
    formData.value.cvc = value;
  }

  function formatExpirationDate(event) {
    let value = event.target.value.replace(/\D/g, '');
    
    if (value.length >= 2) {
      value = value.substring(0, 2) + '/' + value.substring(2, 4);
    }
    
    formData.value.expirationDate = value;
  }

  function handleSubmit() {
    if (isFormValid.value) {
      loader_profile.value = true;
      
      // Simular procesamiento de pago
      setTimeout(() => {
        loader_profile.value = false;
        tittle.value = 'Éxito';
        typeMsg.value = 'success';
        msg.value = 'Pago procesado correctamente';
        toastAlert.value = true;
        
        // Resetear formulario
        formData.value = {
          fullName: '',
          cardNumber: '',
          cvc: '',
          expirationDate: ''
        };
        
        setTimeout(() => {
          toastAlert.value = false;
        }, 3000);
      }, 2000);
    }
  }
</script>

<style>

</style>
